"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnlineLink = exports.RetryLink = exports.AuthenticationLink = void 0;
const apollo_link_1 = require("apollo-link");
const apollo_link_retry_1 = require("apollo-link-retry");
Object.defineProperty(exports, "RetryLink", {
  enumerable: true,
  get: function () {
    return apollo_link_retry_1.RetryLink;
  }
});
const authentication_1 = __importDefault(require("./authentication"));
exports.AuthenticationLink = authentication_1.default;
const OnlineLink = (networkLink, _ref) => {
  let expired = _ref.expired,
    getToken = _ref.sessionToken,
    format = _ref.headerFormat,
    refreshToken = _ref.refreshToken,
    setSessionToken = _ref.setSessionToken,
    reauthenticate = _ref.reauthenticate,
    tokenInvalid = _ref.tokenInvalid,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? {
      initial: 250,
      max: 5000,
      jitter: true
    } : _ref$delay,
    _ref$attempts = _ref.attempts,
    attempts = _ref$attempts === void 0 ? {
      max: 4,
      retryIf: error => !!error
    } : _ref$attempts;
  return apollo_link_1.ApolloLink.from([new apollo_link_retry_1.RetryLink({
    delay,
    attempts
  }), (0, authentication_1.default)({
    getToken,
    expired,
    format,
    tokenInvalid,
    reauthenticate: () => __awaiter(void 0, void 0, void 0, function* () {
      let newToken = null;
      const token = refreshToken();
      if (!token) {
        return newToken;
      }
      newToken = yield reauthenticate(token);
      setSessionToken(newToken);
      return newToken;
    })
  }), networkLink]);
};
exports.OnlineLink = OnlineLink;